import * as React from "react";
const SvgIcAave24 = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, ...props }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "a", gradientUnits: "userSpaceOnUse", x1: 1, y1: 0, x2: -0.42, y2: 1.4, gradientTransform: "scale(24)" }, /* @__PURE__ */ React.createElement("stop", { offset: 0, style: {
  stopColor: "#b6509e",
  stopOpacity: 1
} }), /* @__PURE__ */ React.createElement("stop", { offset: 1, style: {
  stopColor: "#2ebac6",
  stopOpacity: 1
} }))), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "url(#a)"
}, d: "M24 12c0 6.629-5.371 12-12 12S0 18.629 0 12 5.371 0 12 0s12 5.371 12 12Zm0 0" }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "#fff",
  fillOpacity: 1
}, d: "m17.32 16.844-4.11-9.938a1.1 1.1 0 0 0-1.03-.761h-.364a1.1 1.1 0 0 0-1.03.761l-1.79 4.328H7.645a.745.745 0 0 0-.739.739v.007a.745.745 0 0 0 .739.739h.726l-1.707 4.125a.853.853 0 0 0-.05.281.802.802 0 0 0 .199.555.718.718 0 0 0 .546.21.736.736 0 0 0 .418-.14.962.962 0 0 0 .297-.375l1.88-4.66h1.3a.745.745 0 0 0 .738-.735v-.02a.745.745 0 0 0-.738-.737h-.695l1.437-3.57 3.906 9.718a.923.923 0 0 0 .297.371c.121.09.27.14.418.14a.714.714 0 0 0 .547-.206.785.785 0 0 0 .2-.555.657.657 0 0 0-.044-.277Zm0 0" }));
export default SvgIcAave24;
